import { render } from "./ChulhaAssignNew2.vue?vue&type=template&id=4bf200d6&scoped=true"
import script from "./ChulhaAssignNew2.vue?vue&type=script&lang=js"
export * from "./ChulhaAssignNew2.vue?vue&type=script&lang=js"

import "./ChulhaAssignNew2.vue?vue&type=style&index=0&id=4bf200d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bf200d6"

export default script